import React from "react";
import {
  FormikErrors,
  FormikProps,
  useFormikContext,
  withFormik,
} from "formik";
import { Button } from "@chakra-ui/button";
import { HStack } from "@chakra-ui/layout";
import { AdminApiClient } from "../api/adminApiClient";
import { FormStack } from "../components/FormStack/FormStack";
import { TextArea } from "../components/fields/TextArea/TextArea";

const emptyStrToNull = (value: string | null): string | null => {
  if (!value || value.trim() === "") {
    return null;
  } else {
    return value;
  }
};

interface IntegrationConfigurationFormValues {
  configuration: string;
}

interface IntegrationConfigurationFormProps {
  apiClient: AdminApiClient;
  businessId: string;
  integrationId: string;
  configuration: { [key: string]: unknown } | null | undefined;
  isDisabled?: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
  onFailure?: (message?: string) => void;
}

const InnerForm = ({
  isSubmitting,
  isDisabled,
  submitForm,
  isValid,
  onCancel,
  values,
}: IntegrationConfigurationFormProps &
  FormikProps<IntegrationConfigurationFormValues>) => {
  const { setFieldValue } = useFormikContext();
  const prettify = () => {
    const jsonObject = JSON.parse(values.configuration);
    setFieldValue("configuration", JSON.stringify(jsonObject, null, 2));
  };
  return (
    <FormStack>
      <TextArea
        label="Configuration"
        name="configuration"
        rows={20}
        fontFamily="jsonTextArea"
      />

      <HStack width="100%" justifyContent="start" spacing="3" pt="4">
        <Button
          colorScheme="cherryButton"
          type="submit"
          isLoading={isSubmitting}
          disabled={isSubmitting || !isValid}
          onClick={submitForm}
        >
          Save
        </Button>
        <Button
          colorScheme="cherryButton"
          disabled={isSubmitting || !isValid}
          onClick={prettify}
        >
          Prettify
        </Button>
        <Button disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
      </HStack>
    </FormStack>
  );
};

export const IntegrationConfigurationForm = withFormik<
  IntegrationConfigurationFormProps,
  IntegrationConfigurationFormValues
>({
  mapPropsToValues: ({ configuration }) => {
    return {
      configuration: !configuration
        ? ""
        : JSON.stringify(configuration, null, 2),
    };
  },
  handleSubmit: async (values, { props, setFieldError }) => {
    let result = await props.apiClient.updateIntegrationConfiguration(
      props.businessId,
      props.integrationId,
      emptyStrToNull(values.configuration) == null
        ? null
        : JSON.parse(values.configuration)
    );

    if (result.ok) {
      if (props.onSuccess) {
        props.onSuccess();
      }
    } else {
      if (props.onFailure) {
        props.onFailure(result.message);
      }
    }
  },

  validateOnBlur: false,
  validateOnMount: false,
  validateOnChange: true,
  validate: (values) => {
    let errors: FormikErrors<IntegrationConfigurationFormValues> = {};

    try {
      if (emptyStrToNull(values.configuration) != null)
        JSON.parse(values.configuration);
    } catch (e) {
      errors.configuration = "Invalid json format.";
    }

    return errors;
  },
})(InnerForm);
